<template>
  <div>
    <v-card
      tile
      flat
      class="headingcardsEnt"
      img="https://sitkatheme.com/travel/wp-content/uploads/sites/7/2019/10/travl6-1920x1374.jpg"
    >
      <div class="filtro">
        <v-card-text class="aling-items-start titular">
          <b-container>
            <h2 class="titulo">Titulo de la entrada</h2>

            <h4 class="categoria">Categoría - Tags</h4>
          </b-container>
        </v-card-text>
      </div>
    </v-card>
    <b-container>
      <b-row>
        <b-col cols="12" md="8">
          <div class="nota">
            <h2>Lorem ipsum</h2>
            <p>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illo, quae eligendi. Reprehenderit cupiditate eius dolorum aspernatur incidunt amet fugiat excepturi odio officiis, nemo
              <strong>laboriosam quidem sint</strong> iste, adipisci consequuntur minima.
            </p>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vitae atque similique inventore unde hic eius, blanditiis dicta suscipit, vero veniam laudantium quisquam voluptatibus nam? Blanditiis error corporis numquam laudantium quam.</p>
            <ol>
              <li>
                <strong>Impenetrable foliage</strong> of my trees, and but a few stray gleams.
              </li>
              <li>
                <strong>A wonderful serenity</strong> has taken possession of my entire soul.
              </li>
              <li>
                <strong>I should be incapable of drawing</strong> a single stroke at the present moment.
              </li>
            </ol>
            <p>One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.</p>
            <p>I feel the presence of the Almighty:</p>
            <v-img
              src="https://demo.goodlayers.com/akea/wp-content/uploads/2018/11/pexels-photo-701449.jpeg"
            ></v-img>
            <p>
              <span class="gdlr-core-space-shortcode" style="margin-top: 45px ;"></span>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.
              <strong>A small river named Duden flows by</strong> their place and supplies it with the necessary regelialia. It is a paradisematic country in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line.
            </p>
            <p>I am so happy, my dear friend, so absorbed in the exquisite sense of mere tranquil existence, that I neglect my talents. I should be incapable of drawing a single stroke at the present moment and yet.</p>
            <blockquote>
              <b-row>
                <b-col cols="4" class="text-center align-self-center">
                  <v-icon color="#79398099" size="x-large" class="quote">mdi-format-quote-open</v-icon>
                </b-col>
                <b-col cols="8" class="align-self-center">
                  <p>
                    <strong>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarks.</strong>
                  </p>
                </b-col>
              </b-row>
            </blockquote>
            <ul>
              <li>
                <strong>Impenetrable foliage</strong> of my trees, and but a few stray gleams.
              </li>
              <li>
                <strong>A wonderful serenity</strong> has taken possession of my entire soul.
              </li>
              <li>
                <strong>I should be incapable</strong> of drawing a single stroke at the present moment.&nbsp;
                <span
                  class="gdlr-core-space-shortcode"
                  style="margin-top: 50px ;"
                ></span>
              </li>
            </ul>
            <iframe
              width="100%"
              height="350"
              src="https://www.youtube.com/embed/6v2L2UGZJAM"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="socialshare py-5">
            <h4 class="titulo mt-5">Compartílo en tus redes sociales</h4>
            <v-list class="d-flex" color="transparent">
              <v-list-item>
                <v-btn icon color="#3b5998">
                  <social-sharing
                    url="https://www.instagram.com/briefcase_app/"
                    quote="Briefcase, más que una app, tu asistente financiero. Disponible en Google Play"
                    inline-template
                  >
                    <div>
                      <network network="facebook">
                        <i class="v-icon mdi mdi-facebook"></i>
                      </network>
                    </div>
                  </social-sharing>
                </v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn icon color="#0077b5">
                  <social-sharing
                    url="instagram.com/briefcase_app"
                    title="Briefcase"
                    description="Briefcase, más que una app, tu asistente financiero. Te ayudamos a administrar correctamente tu dinero desde el celular! 📲 Disponible en Google Play"
                    quote="Más que una app, tu asistente financiero. 📲 Disponible en Google Play"
                    hashtags="#briefcase #BriefcaseTIPS"
                    inline-template
                  >
                    <div>
                      <network network="linkedin">
                        <i class="v-icon mdi mdi-linkedin"></i>
                      </network>
                    </div>
                  </social-sharing>
                </v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn icon color="#0088cc">
                  <social-sharing
                    url="instagram.com/briefcase_app"
                    title="Briefcase"
                    description="Briefcase, más que una app, tu asistente financiero. Te ayudamos a administrar correctamente tu dinero desde el celular! 📲 Disponible en Google Play"
                    quote="Más que una app, tu asistente financiero. 📲 Disponible en Google Play"
                    hashtags="#briefcase #BriefcaseTIPS"
                    inline-template
                  >
                    <div>
                      <network network="telegram">
                        <i class="v-icon mdi mdi-telegram"></i>
                      </network>
                    </div>
                  </social-sharing>
                </v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn icon color="#1da1f2">
                  <social-sharing
                    url="instagram.com/briefcase_app"
                    title="Briefcase, más que una app, tu asistente financiero. Te ayudamos a administrar correctamente tu dinero desde el celular! 📲 Disponible en Google Play #briefcase #briefcaseTIPS"
                    description="Briefcase, más que una app, tu asistente financiero. Te ayudamos a administrar correctamente tu dinero desde el celular! 📲 Disponible en Google Play"
                    quote="Más que una app, tu asistente financiero. 📲 Disponible en Google Play"
                    hashtags="#briefcase #BriefcaseTIPS"
                    inline-template
                  >
                    <div>
                      <network network="twitter">
                        <i class="v-icon mdi mdi-twitter"></i>
                      </network>
                    </div>
                  </social-sharing>
                </v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn icon color="#25D366">
                  <social-sharing
                    url="instagram.com/briefcase_app"
                    title="Briefcase"
                    description="Briefcase, más que una app, tu asistente financiero. Te ayudamos a administrar correctamente tu dinero desde el celular! 📲 Disponible en Google Play"
                    quote="Más que una app, tu asistente financiero. 📲 Disponible en Google Play"
                    hashtags="#briefcase #BriefcaseTIPS"
                    inline-template
                  >
                    <div>
                      <network network="whatsapp">
                        <i class="v-icon mdi mdi-whatsapp"></i>
                      </network>
                    </div>
                  </social-sharing>
                </v-btn>
              </v-list-item>
            </v-list>
          </div>
          <div class="tags">
            <v-btn
              text
              color="#793980"
              class="mr-3"
              v-for="tag in tags"
              :key="tag.nombre"
              :href="'tag/'+tag.nombre"
            >{{tag.nombre}}</v-btn>
          </div>
          <div class="nextprev">
            <b-container>
              <b-row>
                <b-col cols="12" md="6">
                  <v-card class="mx-auto" max-width="100%" outlined>
                    <v-list-item two-line>
                      <v-list-item-avatar tile size="80" color="grey"></v-list-item-avatar>
                      <v-list-item-content>
                        <div class="overline mb-4">
                          <v-icon>mdi-arrow-left</v-icon>POST ANTERIOR
                        </div>
                        <v-list-item-title class="headline mb-1">Titulo del post</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </b-col>
                <b-col cols="12" md="6">
                  <v-card class="mx-auto text-right" max-width="100%" outlined>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <div class="overline mb-4">
                          SIGUIENTE POST
                          <v-icon>mdi-arrow-right</v-icon>
                        </div>
                        <v-list-item-title class="headline mb-1">Titulo del post</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-avatar tile size="80" color="grey"></v-list-item-avatar>
                    </v-list-item>
                  </v-card>
                </b-col>
              </b-row>
            </b-container>
          </div>
          <div class="coments separador">
            <h6 class="titulo my-5 text-center text-uppercase">2 comentarios</h6>
            <v-card
              elevation="0"
              tile
              color="#79398010"
              class="mx-auto margencomentarios"
              max-width="100%"
            >
              <v-list-item two-line>
                <v-list-item-avatar tile size="60" color="transparent">
                  <v-icon color="#793980">mdi-account</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="body-2 mb-3 mt-3 violeta font-weight-bold">Nombre:</v-list-item-title>
                  <p
                    class="body-1"
                  >Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus laudantium aliquid corporis quae fuga unde earum cupiditate ut debitis omnis incidunt atque sapiente consectetur officia expedita accusamus adipisci, quis harum.</p>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            <v-card
              elevation="0"
              tile
              color="#79398010"
              class="margencomentarios mx-auto"
              max-width="100%"
            >
              <v-list-item two-line>
                <v-list-item-avatar tile size="60" color="transparent">
                  <v-icon color="#793980">mdi-account</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="body-2 mb-3 mt-3 violeta font-weight-bold">Nombre:</v-list-item-title>
                  <p
                    class="body-1"
                  >Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus laudantium aliquid corporis quae fuga unde earum cupiditate ut debitis omnis incidunt atque sapiente consectetur officia expedita accusamus adipisci, quis harum.</p>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </div>
          <div class="leavecoment my-5">
            <h4 class="titulo mt-5">Dejá un comentario 😀</h4>
            <v-form ref="form" lazy-validation class="mt-5">
              <v-text-field
                filled
                color="#793980"
                v-model="name"
                :rules="nameRules"
                label="Nombre"
                required
              ></v-text-field>
              <v-textarea
                filled
                clearable
                color="#793980"
                v-model="comentario"
                :rules="comentarioRules"
                label="Comentario"
              ></v-textarea>
              <v-btn dark large color="#793980" v-on:click="validate">Enviar</v-btn>
            </v-form>
          </div>
        </b-col>
        <b-col cols="12" md="4" lg="4">
          <ColumnaDer />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ColumnaDer from "../../components/ColumnaDer";

export default {
  components: {
    ColumnaDer
  },
  data() {
    return {
      name: "",
      nameRules: [v => !!v || "Ingresá un nombre"],
      comentario: "",
      comentarioRules: [v => !!v || "Ingresá un comentario"]
    };
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        console.log("jaja");
      }
    }
  },
   mounted() {
     this.$store.dispatch("categorias/listarTags");
  },
  computed: {
    tags() {
      return this.$store.getters["categorias/verTags"];
    }
  }
};
</script>